const get = require('lodash.get');
const React = require('react');
const { default: SmartLink } = require('../SmartLink');

const scrollTo = (id) => {
  if (typeof window === 'undefined') {
    return;
  }
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({
    behavior: 'smooth',
    offset: 84,
  });
  window.history.pushState({}, '', `#${id}`);
};

exports.text = (text) => {
  return text.split('\n').map((t, i) =>
    i > 0 ? (
      <React.Fragment key={i}>
        <br />
        {t}
      </React.Fragment>
    ) : (
      t
    )
  );
  /*.map((t) => {
      if (typeof t === 'string') {
        return t.replace(/\u2028/g, '');
      }
      return t;
    });*/
};

exports.hyperlink = (node) => {
  const markType = get(node, 'content[0].marks[0].type');
  const isItalic = markType === 'italic';
  const linkText = get(node, 'content[0].value', node.data.uri);
  const uri = get(node, 'data.uri');

  // Handle jump links
  if (uri.indexOf('#') === 0) {
    let id = uri.split('#')[1];
    return (
      /*eslint-disable-next-line*/
      <a style={{ cursor: 'pointer' }} onClick={() => scrollTo(id)} key={`${id}-${linkText}`}>
        {linkText}
      </a>
    );
  }

  let link = (
    <SmartLink key={uri} to={uri}>
      {linkText}
    </SmartLink>
  );

  if (!isItalic) return link;
  return <i key={linkText}>{link}</i>;
};

exports.entryHyperlink = (node) => {
  if (get(node, 'data.target.sys.type') === 'Entry') {
    return (
      <SmartLink to={`/blog/${node.data.target.slug}/`} key={node.data.target.slug}>
        {node.data.target.title}
      </SmartLink>
    );
  }
};

exports.embeddedEntry = (node) => {
  const type = node?.data?.target?.internal?.type;
  if (type === 'ContentfulEmbedLink') {
    return (
      <SmartLink to={node.data.target.url} isExternal={node.data.target.opensNewPage} key={node.data.target.url}>
        {node.data.target.linkText}
      </SmartLink>
    );
  }
};
